<template>
  <div style="padding: 15px">
    <el-form ref="form" :model="form" :rules="rules">
      <el-row>
        <el-col :span="24">
          <el-form-item prop="amount">
            <el-input v-model="form.amount" placeholder="请输入金额" @input="(value)=>formFormatter.isFloor2(value,oldValue,form,'amount')">
              <template slot="prepend">验证金额</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-button type="primary" @click="addClick('form')">确定</el-button>
    </el-form>
  </div>
</template>
<script>
import {
  payCheck
} from "@/api/InternetBanking";
export default {
  name: "MerchantManagementAdd",
  props: {
    merchantId: {
      type: String,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      vardel: false,
      distrue: false,
      provinceList: [],
      cityList: [],
      districtList: [],
      form: {
        amount : "",
      },
      rules: {
        amount: [
          { required: true, message: "请输入打款金额", trigger: "blur" }
        ],
      }
    };
  },
  created() {
  },
  methods: {
    close() {
      this.$refs.form.resetFields();
    },
    //提交
    addClick(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
           var data = Object.assign({}, this.form, { merchantId: this.merchantId })
          payCheck(data).then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: "success" });
            this.$emit("event2");
            this.$refs.form.resetFields();
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.titleh1 {
  line-height: 50px;
  border-bottom: 1px solid #e2e2e2;
  margin-bottom: 15px;
  code {
    width: 5px;
    height: 20px;
    background-color: #ff7f21;
    float: left;
    margin-right: 5px;
    margin-top: 13px;
  }
}
</style>
